import { CustomerDistributionContainer } from '@interhyp/module-case-assignment';
import { BaseLayout, Footer } from '@interhyp/platform-layout';
import React, { Suspense } from 'react';

function CustomerDistributionModule() {
  return (
    <Suspense fallback={null}>
      <BaseLayout>
        <CustomerDistributionContainer />
      </BaseLayout>
      <Footer />
    </Suspense>
  );
}

export { CustomerDistributionModule };
